import { Component } from '@angular/core';

@Component({
  selector: 'app-mapping-options',
  templateUrl: './mapping-options.component.html',
  styleUrls: ['./mapping-options.component.scss']
})
export class MappingOptionsComponent {

}
